module.exports = __webpack_public_path__ + "assets/7e36a51af61ba3a358173a73bf74970c.png";